import { AuditModelDto } from '@treasury/api/bo';
import { DomainEntity } from '../../../shared';

export class AchAuditEntry extends DomainEntity<AuditModelDto> {
    public createDefault(): this {
        return new AchAuditEntry({}) as this;
    }

    public get username() {
        return this.dto.username ?? '';
    }

    public get action() {
        return this.dto.action ?? '';
    }

    public get timestamp() {
        return this.dto.timestamp ?? '';
    }

    public get comments() {
        return this.dto.comments ?? '';
    }
}
